module.exports = __webpack_public_path__ + "static/media/zans.875422dc.png";